/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { cashChallanResult } from "../../../../services/view-challan-service";
import { useNavigate } from "react-router-dom";
import useApiState from "../../common/useApiState";
import Loader from "../../../loader/loader";
import AlertMsg from "../../../common/alert";
import { Alert } from "@mui/material";
import { getErrorMsg } from "../../../../utils/helpers";
import { showToastError } from "../../../common/toastHelper";
import './printStyles.css';

const CashChallan = () => {
  const [lstPCMCTaxList, setlstPCMCTaxList] = useState([]);
  const [lstGovTaxList, setlstGovTaxList] = useState([]);
  const [lstExtraTaxList, setlstExtraTaxList] = useState([]);
  const [lstDenominationList, setlstDenominationList] = useState([]);
  const [otherDetails, setOtherDetails] = useState("");
  const { loading, setLoading, error, setError } = useApiState();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const body = window.localStorage.getItem("CashChallanInput");
      if (body) {
        try {
          setLoading(true);
          const response = await cashChallanResult(JSON.parse(body));
          setlstPCMCTaxList(response.lstPCMCTax);
          setlstGovTaxList(response.lstGovTax);
          setlstExtraTaxList(response.lstExtraTax);
          setlstDenominationList(response.lstDenomination);
          setOtherDetails(response);
        } catch (error) {
          showToastError(getErrorMsg(error));
        } finally {
          setLoading(false);
        }
      }
    };
    if (!otherDetails) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty dependency array ensures it runs only once

  const printRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => printRef.current, // Reference the section you want to print
    documentTitle: "Cash Challan", // Optional: customize document title
  });

  useEffect(() => {
    return () => {
      window.localStorage.removeItem("CashChallanInput");
    };
  }, []);

  return (
    <div style={{ margin: "15px" }}>
      <div>
        {loading && <Loader />}
        {error && (
          <AlertMsg
            message={error}
            severity="error"
            onClose={() => {
              setError("");
            }}
          />
        )}
      </div>
      <>
        <div style={{ display: "inline" }}>
          <a href="#" onClick={(e) => { e.preventDefault(); handlePrint(); }} alt="Print Report">
            PRINT
          </a>
        </div>
        <a
          href="#"
          onClick={() => {
            navigate(-1);
          }}
          alt="Back"
          style={{ float: "right" }}
        >
          Back
        </a>
      </>
      {otherDetails ? (
        <>
          <div style={{ width: "100%" }}  ref={printRef}>
            <div style={{ float: "left", width: "50%" }}>
              <table
                width="100%"
                cellPadding="0"
                cellSpacing="1"
                border="0px solid"
                style={{ fontFamily: "Arial", fontSize: 9 }}
              >
                <tbody>
                  <tr>
                    <td style={{ width:"60px"}}>
                      <img
                        src="/pcmclogo.jpeg"
                        alt="PCMC"
                        style={{ maxWidth: "100%", height: "8vh" }}
                      />
                    </td>
                    <td>
                      <table>
                        <tr>
                          <td
                            valign="top"
                            style={{ fontSize: 10, fontWeight: 700 }}
                          >
                            पिंपरी चिंचवड महानगरपालिका, पिंपरी १८
                          </td>
                        </tr>
                        <tr>
                          <td valign="top" style={{ fontSize: 9 }}>
                            {otherDetails.zoneName} कर आकारणी व कर संकलन विभाग{" "}
                            {otherDetails.counterName}
                          </td>
                        </tr>
                        <tr>
                          <td valign="top" style={{ fontSize: 9 }}>
                            Cash वसूल केलेल्या रकमा मुख्य कार्यालयातील कोषागारात
                            / बँकेत भरावयाचे चलन
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
              <table
                width="100%"
                cellPadding="0"
                cellSpacing="1"
                border="0px solid"
                style={{ fontFamily: "Arial", fontSize: 9 }}
              >
                <tbody>
                  <tr>
                    <td valign="top">
                      <table
                        width="100%"
                        cellPadding="0"
                        cellSpacing="0"
                        border="1"
                        style={{ lineHeight: "1.5" }}
                      >
                        <tbody>
                          <tr>
                            <td align="center">नाव</td>
                            <td align="center" colSpan="2">
                              पावती नंबर
                            </td>
                            <td align="center" colSpan="3">
                              भरणा तपशील
                            </td>
                          </tr>
                          <tr>
                            <td align="center"></td>
                            <td align="center">पासून</td>
                            <td align="center">पर्यंत</td>
                            <td align="center">मागील</td>
                            <td align="center">चालू</td>
                            <td align="center">एकूण</td>
                          </tr>
                          <tr>
                            <td
                              align="left"
                              colSpan="6"
                              style={{ fontWeight: "bold" }}
                            >
                              म.न.पा. कर
                            </td>
                          </tr>
                          {lstPCMCTaxList.map((item, index) => (
                            <tr>
                              <td align="left" style={{ fontSize: "9px" }}>
                                {item.headName}
                              </td>
                              <td align="center" style={{ fontSize: "8px" }}>
                                {item.receiptFrom}
                              </td>
                              <td align="center" style={{ fontSize: "8px" }}>
                                {item.receiptTo}
                              </td>
                              <td align="center" style={{ fontSize: "8px" }}>
                                {item.lblPrevious}
                              </td>
                              <td align="center" style={{ fontSize: "8px" }}>
                                {item.lblCurrent}
                              </td>
                              <td align="center" style={{ fontSize: "8px" }}>
                                {item.lblTotal}
                              </td>
                            </tr>
                          ))}
                          <tr>
                            <td
                              align="right"
                              colSpan="3"
                              style={{ fontWeight: "bold" }}
                            >
                              सबटोटल
                            </td>
                            <td align="center">
                              {otherDetails.lblPCMCPreviousTot}
                            </td>
                            <td align="center">
                              {otherDetails.lblPCMCCurrentTot}
                            </td>
                            <td align="center">{otherDetails.lblPCMCTotal}</td>
                          </tr>

                          <tr>
                            <td
                              align="left"
                              colSpan="6"
                              style={{ fontWeight: "bold" }}
                            >
                              शासन कर
                            </td>
                          </tr>
                          {lstGovTaxList.map((item1, index1) => (
                            <tr>
                              <td align="left" style={{ fontSize: "9px" }}>
                                {item1.headName}
                              </td>
                              <td align="center" style={{ fontSize: "8px" }}>
                                {item1.receiptFrom}
                              </td>
                              <td align="center" style={{ fontSize: "8px" }}>
                                {item1.receiptTo}
                              </td>
                              <td align="center" style={{ fontSize: "8px" }}>
                                {item1.lblPrevious}
                              </td>
                              <td align="center" style={{ fontSize: "8px" }}>
                                {item1.lblCurrent}
                              </td>
                              <td align="center" style={{ fontSize: "8px" }}>
                                {item1.lblTotal}
                              </td>
                            </tr>
                          ))}
                          <tr>
                            <td
                              align="right"
                              colSpan="3"
                              style={{ fontWeight: "bold" }}
                            >
                              सबटोटल
                            </td>
                            <td align="center">
                              {otherDetails.lblGovPreviousTot}
                            </td>
                            <td align="center">
                              {otherDetails.lblGovCurrentTot}
                            </td>
                            <td align="center">{otherDetails.lblGovTotal}</td>
                          </tr>
                          {lstExtraTaxList.map((item2, index2) => (
                            <tr>
                              <td align="left" style={{ fontSize: "9px" }}>
                                {item2.headName}
                              </td>
                              <td align="center" style={{ fontSize: "8px" }}>
                                {item2.receiptFrom}
                              </td>
                              <td align="center" style={{ fontSize: "8px" }}>
                                {item2.receiptTo}
                              </td>
                              <td align="center" style={{ fontSize: "8px" }}>
                                {item2.lblPrevious}
                              </td>
                              <td align="center" style={{ fontSize: "8px" }}>
                                {item2.lblCurrent}
                              </td>
                              <td align="center" style={{ fontSize: "8px" }}>
                                {item2.lblTotal}
                              </td>
                            </tr>
                          ))}
                          <tr>
                            <td
                              align="right"
                              colSpan="3"
                              style={{ fontWeight: "bold" }}
                            >
                              सबटोटल
                            </td>
                            <td align="center">
                              {otherDetails.lblExtraPreviousTot}
                            </td>
                            <td align="center">
                              {otherDetails.lblExtraCurrentTot}
                            </td>
                            <td align="center">{otherDetails.lblExtraTotal}</td>
                          </tr>
                          <tr>
                            <td
                              align="right"
                              colSpan="3"
                              style={{ fontWeight: "bold" }}
                            >
                              एकूण रक्कम
                            </td>
                            <td align="center">
                              {otherDetails.lblAllPreviousTot}
                            </td>
                            <td align="center">
                              {otherDetails.lblAllCurrentTot}
                            </td>
                            <td align="center">{otherDetails.lblAllTotal}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div style={{ float: "right", width: "47%" }}>
              <table
                width="100%"
                align="center"
                style={{ fontFamily: "Arial", fontSize: 10 }}
              >
                <tbody>
                  <tr>
                    <td align="center">भरणा चलन</td>
                    <td align="center">
                      विभाग चलन नं. - <span>{otherDetails.lblChalanNo}</span>
                    </td>
                  </tr>
                  <tr>
                    <td align="center">मा. मुख्य लेखापाल</td>
                    <td align="center">
                      दिनांक - &nbsp;<span>{otherDetails.receiptDate}</span>
                    </td>
                  </tr>
                  <tr>
                    <td align="center">
                      सहा. मंडलाधिकारी <label>{otherDetails.zoneName}</label>{" "}
                      विभाग यांजकडून एकूण भरणा रक्कम रुपये (
                      {otherDetails.lblChalanAmnt})
                    </td>
                  </tr>
                  <tr>
                    <td align="left">
                      अक्षरी &nbsp;&nbsp;&nbsp;
                      <span>{otherDetails.lblChalanAmntInWords}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      फ़क्त चा भरणा केला आहे. तो जमा करुन पावती देणेत यावी.
                    </td>
                  </tr>
                  <tr>
                    <td align="left"></td>
                    <td align="right">सहा. मंडलाधिकारी</td>
                  </tr>
                  <tr>
                    <td align="left">पावती</td>
                    <td align="right"></td>
                  </tr>

                  <tr>
                    <td align="left">
                      वरील प्रमाणे एकूण रक्क्म रुपये (
                      {otherDetails.lblChalanAmnt})<span>&nbsp;</span>
                    </td>
                  </tr>
                  <tr>
                    <td align="left">
                      अक्षरी &nbsp;&nbsp;&nbsp;
                      <span>{otherDetails.lblChalanAmntInWords}</span>
                    </td>
                  </tr>
                  <tr>
                    <td align="left">
                      फ़क्त चा भरणा केला आहे. तो जमा करुन पावती देणेत यावी.
                      &nbsp;&nbsp;&nbsp;<span></span>
                    </td>
                  </tr>
                  <tr>
                    <td>{/* lblOnly */}</td>
                  </tr>
                  <tr>
                    <td align="left"></td>
                    <td align="right">रोखापाल यांची स्वाक्षरी</td>
                  </tr>
                  <tr>
                    <td
                      align="center"
                      colSpan={2}
                      style={{ fontWeight: "bold" }}
                    >
                      तपशील रोख रु.
                    </td>
                  </tr>
                </tbody>
              </table>
              <br />
              <div>
                <table
                  width="80%"
                  align="center"
                  cellPadding="0"
                  cellSpacing="1"
                  border="1"
                  style={{
                    fontFamily: "Arial",
                    borderCollapse: "collapse",
                    fontSize: 8,
                    lineHeight: "1.5",
                  }}
                >
                  <tbody>
                    {lstDenominationList.map((item3, index3) => (
                      <tr>
                        <td align="center" style={{ fontSize: "8px" }}>
                          {item3.denomination}
                        </td>
                        <td align="center" style={{ fontSize: "8px" }}>
                          X
                        </td>
                        <td align="center" style={{ fontSize: "8px" }}>
                          {item3.noOfDenomination}
                        </td>
                        <td align="center" style={{ fontSize: "8px" }}>
                          =
                        </td>
                        <td align="center" style={{ fontSize: "8px" }}>
                          {item3.denoTotal}
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <td align="center" colSpan="3"></td>
                      <td align="center">एकूण</td>
                      <td align="center" style={{ fontSize: "8px" }}>
                        {otherDetails.lblChalanAmnt}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <br />

              <table
                width="80%"
                align="center"
                cellPadding="0"
                cellSpacing="1"
                border="1"
                style={{
                  borderCollapse: "collapse",
                  fontFamily: "Arial",
                  fontSize: 8,
                  lineHeight: "1.5",
                }}
              >
                <tbody>
                  <tr>
                    <td
                      align="center"
                      colSpan={6}
                      style={{ fontWeight: "bold" }}
                    >
                      रद्द पावत्या
                    </td>
                  </tr>
                  <tr>
                    <td align="center">मालमता क्र.</td>
                    <td align="center">मालमत्तेचे नाव</td>
                    <td align="center">पिं.चिं.म.न.पा.</td>
                    <td align="center">रद्द पावती दि.</td>
                    <td align="center">पावती रक्कम</td>
                    <td align="center">कारण</td>
                  </tr>
                  {otherDetails?.lstCancelReceipt?.length > 0 ? (
                    otherDetails.lstCancelReceipt.map((item4, index4) => (
                      <tr>
                        <td align="center">{item4.propertyCode}</td>
                        <td align="center">{item4.propertyName}</td>
                        <td align="center">{item4.deptName}</td>
                        <td align="center">{item4.receiptDate}</td>
                        <td align="center">{item4.receiptAmnt}</td>
                        <td align="center">{item4.reason}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td align="center" colspan="6">
                        माहिती उपलब्ध नाही
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </>
      ) : (
        <div>
          {!loading && !error && (
            <Alert
              severity="error"
              onClose={() => {
                setError("");
              }}
            >
              Data not loaded please go back and try again!!
            </Alert>
          )}
        </div>
      )}
    </div>
  );
};

export default CashChallan;
